import NetworkingOperations from "../index";

const GetEmail = (data) => {
	const url = process.env.REACT_APP_GET_EMAIL_RECEIPT;

	return NetworkingOperations.post({ url, data }).then((res) => res);
};

export default GetEmail;
